export function getUTCOffset(offsetMinutes: number) {
  const west = offsetMinutes > 0 ? '-' : '+';
  const hours = Math.abs(Math.trunc(offsetMinutes / 60));
  const hoursOffset = hours < 10 ? '0' : '';
  const minutes = Math.abs(offsetMinutes) - hours * 60;
  const minutesOffset = minutes < 10 ? '0' : '';

  return `${west}${hoursOffset}${hours}${minutesOffset}${minutes}`;
}
